export default __webpack_public_path__ + "static/media/6.cbb05817.jpg";